var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`
    workbench-waggon-waggon
    mr-1 ml-1
    t-rounded
    t-shadow
    font-weight-light
    ${_vm.$vuetify.theme.isDark ? 'grey darken-3' : 'grey lighten-3'}
  `,style:(`height: ${_vm.height}; top: calc(100% - ${_vm.height})`)},[_c('div',{staticClass:"workbench-waggon-waggon-activator"},[_vm._t("activator")],2),_c('div',{staticClass:"workbench-waggon-waggon-tabs"},[_vm._t("tabs")],2),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }